/** "5476", "OC5476", "oc 5476" o "CP-005476" → "CP-005476". Otro formato se deja como viene (en mayúsculas). */
export function normalizarNumeroOC(texto) {
    const t = texto.trim().toUpperCase();
    const m = /^(?:CP-?|OC\s*-?)?\s*(\d{1,6})$/.exec(t);
    return m?.[1] ? `CP-${m[1].padStart(6, '0')}` : t;
}
//# sourceMappingURL=numeroOC.js.map